module.exports = __webpack_public_path__ + "media/images/landings/promotion_3/img_flow-02-780623e1194506ff24e46dbd30340d1a.png";